import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

/** Inline loading indicator. Use inside buttons via `<Button loading />`. */
export const Spinner = ({ className }: { className?: string }) => (
  <span role="status" aria-live="polite" className="inline-flex">
    <Loader2 className={cn("size-4 animate-spin", className)} aria-hidden />
    <span className="sr-only">Loading</span>
  </span>
);
